export default __webpack_public_path__ + "static/media/iphone.a6ff43c3.jpg";